import { render, staticRenderFns } from "./PasswordResetSuccess.vue?vue&type=template&id=4d09b48e&scoped=true"
import script from "./PasswordResetSuccess.vue?vue&type=script&lang=ts"
export * from "./PasswordResetSuccess.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetSuccess.vue?vue&type=style&index=0&id=4d09b48e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d09b48e",
  null
  
)

export default component.exports